module.exports = __webpack_public_path__ + "static/media/fi.58bcc4af.svg";